// src/features/executive/insight/usedStyle.tsx
import { Box, styled } from '@mui/material'

export const TabRoot = styled(Box)(({ theme }) => ({
  paddingTop: theme.spacing(3),
  paddingBottom: theme.spacing(3),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4),  // larger gap between sections vs within sections
}))

// Section wraps a header + one or more rows. Compact internal gap so the
// header stays visually anchored to its content.
export const Section = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1.5),
}))

// 2-column row — for sections with exactly 2 widgets (Profile, Retention).
export const Row2 = styled(Box)(({ theme }) => ({
  display: 'grid',
  gap: theme.spacing(2),
  gridTemplateColumns: '1fr',
  alignItems: 'stretch',
  [theme.breakpoints.up('md')]: { gridTemplateColumns: 'repeat(2, 1fr)' },
}))

// 3-column row — for Channels section.
export const Row3 = styled(Box)(({ theme }) => ({
  display: 'grid',
  gap: theme.spacing(2),
  gridTemplateColumns: '1fr',
  alignItems: 'stretch',
  [theme.breakpoints.up('sm')]: { gridTemplateColumns: 'repeat(2, 1fr)' },
  [theme.breakpoints.up('md')]: { gridTemplateColumns: 'repeat(3, 1fr)' },
}))

// 4-column row — for Demographics section (4 donut/bar widgets fit one row).
export const Row4 = styled(Box)(({ theme }) => ({
  display: 'grid',
  gap: theme.spacing(2),
  gridTemplateColumns: '1fr',
  alignItems: 'stretch',
  [theme.breakpoints.up('sm')]: { gridTemplateColumns: 'repeat(2, 1fr)' },
  [theme.breakpoints.up('lg')]: { gridTemplateColumns: 'repeat(4, 1fr)' },
}))

// Trend-row layout: time-series gets 2/3 width, companion donut/tile 1/3.
export const TrendRow = styled(Box)(({ theme }) => ({
  display: 'grid',
  gap: theme.spacing(2),
  gridTemplateColumns: '1fr',
  alignItems: 'stretch',
  [theme.breakpoints.up('md')]: { gridTemplateColumns: '2fr 1fr' },
}))

// Legacy alias — older code imported `Row`. Default Row3 keeps existing
// behaviour for any leftover usage.
export const Row = Row3
